'use client';
import React from 'react';
import { useState } from "react";
import useMioForm from "../shared/useMioForm.jsx"
import Wrapper from "../shared/Wrapper.jsx"
import { useWatch } from "react-hook-form";
import { PiCheckFatFill } from "react-icons/pi";
function MioCheck(p) {
    const { mioID, field, isDirty, isInvalid, isTouched } = useMioForm(p.name, p.required);
    const [val, setVal] = useState(false);
    const value = useWatch({ name: p.name });

    return (
        <Wrapper {...p} mioID={mioID} isInvalid={isInvalid} isTouched={isTouched} isDirty={isDirty} checkbox>
            <div className="mio-form-control-wrapper mtwi">
                <div className=" mtwt">
                    <div className={` mtwt-box ${value && 'mio-form-control-toggle-checked mtwt-box-checked'}`} onClick={() => field.onChange(!value)}>
                        <div className="mtwt-handle">
                            <PiCheckFatFill />
                        </div>
                    </div>
                </div>
                {/* <input
                    className={`
                        mio-form-control-input
                        ${p.tabular && 'tabular'}
                        `}
                    id={mioID}
                    placeholder={p.placeholder}
                    autoComplete="off"
                    {...field}
                    value={field.value ?? ''}
                ></input> */}
            </div>
        </Wrapper >
    )
}
export default MioCheck